import React from 'react';
import HistoryItem from './HistoryItem';

//OK: export default function History({ transactions }){
/*
OK:
  {<HistoryItem/>}
  {[<HistoryItem/> ]}
  {[<HistoryItem/>, <HistoryItem/>, <HistoryItem/>]}
same as:
  <HistoryItem/> <HistoryItem/> <HistoryItem/>
*/  
const History = ({transactions,delTransaction}) => {
  return (
    <section className="history">
      <h3>История расходов</h3>
      <ul className="history__list">
        {transactions.map((item) => 
          <HistoryItem 
            transaction={item} 
            key={item.id}
            delTransaction={delTransaction}
          />)}
      </ul>
    </section>
  );
}

export default History; //for function-in-a-variable also for functions
